import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCurrentOrg, useCurrentUser } from 'auth/hooks'
import { getFeatures } from '../selectors'
import { getFeaturesForUser, getProductFeaturesForOrg, updateProductFeature } from '../actions'

const NEW_EVENT_FEATURE_KEYS = [
  'ChangeTimeForShiftsWithRegistrations',
  'LocationsManagement',
  'MaintainEventSequencesAcrossEdits',
  'NewAddEventUICalendarEvent',
  'NewAddEventUILegacyFallback',
  'NewEditEventUICalendarEvent',
  'OpportunityTemplates',
  'RecurrenceTimeZoneFix',
  'SimplifyRecurringEventRules',
  'StandaloneOffers',
]

const isEnabled = (features, key) => {
  const feature = features[key]
  return feature && !!feature.enabled
}

export const useFeatureEnabled = key => {
  let features = useSelector(getFeatures)
  return (NEW_EVENT_FEATURE_KEYS.includes(key) && isEnabled(features, 'Post2025Events')) || isEnabled(features, key)
}

export const useReloadLocalFeatures = () => {
  const dispatch = useDispatch()
  const user = useCurrentUser()

  return useCallback(() => {
    dispatch(getFeaturesForUser(user))
  }, [user, dispatch])
}

export const useReloadProductFeatures = () => {
  const dispatch = useDispatch()
  const organization = useCurrentOrg()

  return useCallback(() => {
    dispatch(getProductFeaturesForOrg(organization))
  }, [organization, dispatch])
}

export const useUpdateProductSwitch = () => {
  const dispatch = useDispatch()

  return useCallback(
    ({ feature, organization, enabled }) => {
      dispatch(updateProductFeature(organization, feature, enabled))
    },
    [dispatch],
  )
}

export { default as useOrganizationSettingsTabs } from './useOrganizationSettingsTabs'
export { default as useMigrateQuestionnairesConfirmationPrompt } from './useMigrateQuestionnairesConfirmationPrompt'

export { default as useGetFeatureSet } from './useGetFeatureSet'
export { default as useFeatureEnabledForOrg } from './useFeatureEnabledForOrg'
